module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAcBAMAAABv4amZAAAAGFBMVEWeAx6dAx6dAx+bAh2dAh6dAx2eAx6dAx6xwZbUAAAAB3RSTlP38KeA6Z5U64bb/QAAAB9JREFUGNNjEGBAAiwGDOzlSKBwlD/AfIz4UUIGqgkAumSepLCZnDgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd116/h2-1.png
// module id = yCDt
// module chunks = 1